var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('tools'),_c('preference'),_c('desktop'),_c('dock',{ref:"dock_model"}),_c('notice-tip',{ref:"notice_tip_model"}),_c('notification-center'),_c('copyright')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }